export const getInitials = (first, last) => `${first?.[0] ?? ""}${last?.[0] ?? ""}`.toUpperCase();
export const formatDOB = (dob) => { if (!dob) return "—"; const d = new Date(dob + "T00:00:00"); return isNaN(d) ? "—" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); };
export const calcAge = (dob) => { const diff = Date.now() - new Date(dob); return Math.floor(diff / 31557600000); };
export const timeToMinutes = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
export const formatDateDisplay = (d) => d ? new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
export const fmt12 = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); const ampm = h >= 12 ? "PM" : "AM"; const hour = h % 12 || 12; return `${hour}:${String(m).padStart(2, "0")} ${ampm}`; };
// today's LOCAL calendar date as YYYY-MM-DD. Replaces `new Date().toISOString().split('T')[0]`,
// which returns the UTC date — a day ahead in the evening for UTC-negative zones (e.g. Arizona
// UTC-7), causing visit/order/appointment dates and "today" filters to land on the wrong day.
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
// LOCAL calendar date N days from today as YYYY-MM-DD (for due-date / lookahead defaults).
export const addDaysISO = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
